import { render, staticRenderFns } from "./StaffDataTable.vue?vue&type=template&id=31a62108"
import script from "./StaffDataTable.vue?vue&type=script&lang=js"
export * from "./StaffDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports